export default __webpack_public_path__ + "static/media/myloanweb.24fc2738.png";